import { themeVars, type ResolvedConfig } from '@nvd/claim-shared';

/** The merchant's tokens become CSS custom properties; the stylesheet only ever reads variables. */
export function applyTheme(root: HTMLElement, config: ResolvedConfig): void {
  for (const [name, value] of Object.entries(themeVars(config.theme, config.brand))) {
    root.style.setProperty(name, value);
  }
}
